import React from 'react';
import { Box } from '@mui/material';

/**
 * TabPanel Component
 *
 * Reusable tab panel component for theme customizer tabs.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Content to display in the panel
 * @param {number} props.value - Current active tab index
 * @param {number} props.index - This panel's index
 */
function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`theme-tabpanel-${index}`}
      aria-labelledby={`theme-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default TabPanel;
